import React from 'react';
import isEmpty from 'lodash/isEmpty';

import { IsDisabled } from '../../../../../types';

import {
  FetchLifestylesFilters,
  LifestyleClientID,
  ChangeLifestylesFiltersFunc
} from '../../../lifestylesTypes';

import { useLifestylesTypesFilter } from './hooks/useLifestylesTypesFilter';

import { AlertMessage } from '../../../../../helpers/AlertMessage';
import { LoadingSkeleton } from '../../../../../helpers/LoadingSkeleton';
import { CheckboxGroupFilter } from '../../../../../helpers/filters/CheckboxGroupFilter';
import { Translate } from '../../../../../helpers/Translate';

import { categoriesKeys } from '../../../../../locales/keys';

interface LifestylesTypesFilterProps {
  clientIds?: LifestyleClientID[];
  lifestylesFilters: FetchLifestylesFilters;
  disabled?: IsDisabled;
  changeLifestylesFilters: ChangeLifestylesFiltersFunc;
}

const name = 'lifestyleTypeId' as const;

function LifestylesTypesFilter({
  clientIds,
  lifestylesFilters,
  disabled,
  changeLifestylesFilters
}: LifestylesTypesFilterProps) {
  const filterValue = lifestylesFilters?.[name]?.in;

  const {
    allLifestylesTypesFilterData,
    lifestyleTypesFilterErrorMessage,
    lifestyleTypesFilterFetched,
    lifestyleTypesFilterIsPlaceholderData,
    handleChangeLifestylesTypesFilter
  } = useLifestylesTypesFilter({
    clientIds,
    selectedIds: filterValue,
    name,
    lifestylesFilters,
    changeLifestylesFilters
  });

  if (
    (lifestyleTypesFilterIsPlaceholderData || lifestyleTypesFilterFetched) &&
    isEmpty(allLifestylesTypesFilterData)
  ) {
    return null;
  }

  return (
    <div className="p-4">
      <div className="flex mb-3">
        <h6 className="font-light uppercase">
          <Translate id={categoriesKeys.type} />
        </h6>
      </div>
      <AlertMessage message={lifestyleTypesFilterErrorMessage} />
      <LoadingSkeleton
        loaded={
          lifestyleTypesFilterIsPlaceholderData || lifestyleTypesFilterFetched
        }
      >
        <CheckboxGroupFilter
          dataGa="lifestyle-type-filter"
          inputWrapperClassName="flex flex-col sm:flex-row sm:flex-wrap -mb-2"
          name={name}
          items={allLifestylesTypesFilterData}
          value={lifestylesFilters?.[name]?.in as string[]}
          disabled={disabled}
          onChange={handleChangeLifestylesTypesFilter}
        />
      </LoadingSkeleton>
    </div>
  );
}

export default LifestylesTypesFilter;
